var map = {
	"./1.svg": 28074,
	"./2.svg": 43945,
	"./3.svg": 51289,
	"./4.svg": 55036,
	"./5.svg": 65918,
	"./6.png": 6281,
	"./7.png": 10160,
	"./8.png": 42595,
	"./9.png": 46095
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 74393;